import { Table, Thead, Tbody, Tr, Th, Td, SkeletonText } from "@reverb-ui/react";

export type TSortedTableSkeletonProps = {
    numberOfColumns?: number;
    numberOfRows?: number;
  };

const isLoaded : boolean = false;

export const SortedTableSkeleton = ({
    numberOfColumns = 5,
    numberOfRows = 6,
  } : TSortedTableSkeletonProps) => {
  return (
    <Table h="min-content" variant="simple">
      <Thead>
        <Tr>
          {Array(numberOfColumns).fill(0).map((item, index) => (    
            <Th height={"100%"} borderBottomColor="gray.400" key={index}>
              <SkeletonText isLoaded={isLoaded} variant="rect" noOfLines={1} width={"100%"} skeletonHeight={"1.7rem"}></SkeletonText>
            </Th>
          ))}
        </Tr>
      </Thead>
      <Tbody>
        {Array(numberOfRows).fill(0).map((item, index) => (
          <Tr key={index}>
            {Array(numberOfColumns).fill(0).map((item, index) => (
              <Td key={index}>
                <SkeletonText isLoaded={isLoaded} variant="rect" noOfLines={1} width={"100%"} marginTop={"5%"}></SkeletonText>
              </Td>
              ))}
          </Tr>
         ))}
      </Tbody>
    </Table>
  );
};
